<div app-landing-page-section-container class="items-center">
    <div class="mat-headline-6 text-center pb-4" translate>
        LandingPagePlanningHeadline
    </div>

    <div
        class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8 lg:gap-10 mt-4 md:mt-6 px-0 md:px-20 lg:px-10"
    >
        @for (useCase of useCases; track useCase; let last = $last) {
            <div
                class="mx-auto"
                [class.lg:col-span-2]="last"
                [class.xl:col-span-1]="last"
            >
                <div
                    [ngClass]="[
                        'flex flex-col h-full lg:max-w-[360px] xl:max-w-full',
                    ]"
                >
                    <div
                        [ngClass]="[
                            'bg-' + useCase.color,
                            'flex flex-col shrink-0 rounded-top bg-svg',
                            'h-[150px] lg:h-[201px]',
                        ]"
                    >
                        <div class="grow"></div>
                        <div
                            class="shrink mat-headline-6 pl-8 pb-8 text-white font-bold"
                        >
                            <div class="block sm:hidden lg:block">
                                {{ useCase.titleLine1 | translate }} <br />
                                {{ useCase.titleLine2 | translate }}
                            </div>
                            <div class="hidden sm:block lg:hidden">
                                {{
                                    (useCase.titleLine1 | translate)?.replace(
                                        '-',
                                        ''
                                    )
                                }}{{ useCase.titleLine2 | translate }}
                            </div>
                        </div>
                    </div>

                    <div class="bg-white m-0 rounded-bottom h-full">
                        <p class="mat-body-1 p-8">
                            {{ useCase.description | translate }}
                        </p>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
